var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreentik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(18916.074 -670.926)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 48,
    height: 48,
    rx: 24,
    transform: "translate(-18916.074 670.926)",
    fill: "#39b349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_8666665_check_icon",
    "data-name": "8666665_check_icon",
    d: "M30.567,6,12.3,24.265,4,15.963",
    transform: "translate(-18909.221 679.603)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentik);
export default __webpack_public_path__ + "static/media/greentik.b193902efdeca61922f979cad22a0909.svg";
export { ForwardRef as ReactComponent };